export const slugToNameMapper: Record<string, { singular: string; plural: string }> = {
  'spooky-treats-festival-lv1': {
    singular: 'Eyeball Candy',
    plural: 'Eyeball Candies',
  },
  'spooky-treats-festival-lv2': {
    singular: 'Skull Lollipop',
    plural: 'Skull Lollipops',
  },
  'spooky-treats-festival-lv3': {
    singular: 'Pumpkin Cookie',
    plural: 'Pumpkin Cookies',
  },
};

export const slugIds = ['spooky-treats-festival-lv1', 'spooky-treats-festival-lv2', 'spooky-treats-festival-lv3'];

export const howToGetMapper = {
  'spooky-treats-festival-lv1': [
    {
      title: 'Make a new net deposit',
      requiredCondition: '200 USDT',
      obtainToken: 1,
      isTradingTask: true,
    },
    {
      title: 'Trade more than',
      requiredCondition: '10,000 USDT',
      obtainToken: 1,
      isTradingTask: true,
    },
    {
      title: 'Trade more than',
      requiredCondition: '30,000 USDT',
      obtainToken: 1,
      isTradingTask: true,
    },
    {
      title: 'Trade more than',
      requiredCondition: '50,000 USDT',
      obtainToken: 1,
      isTradingTask: true,
    },
    {
      title: 'Trade more than',
      requiredCondition: '100,000 USDT',
      obtainToken: 1,
      isTradingTask: true,
    },
    // {
    //   title: 'Invite friends through referral link',
    //   requiredCondition: '1 friend completes identity verification',
    //   obtainToken: 1,
    //   isTradingTask: false,
    // },
    {
      title: 'For every increase in',
      requiredCondition: '300 participants',
      obtainToken: 1,
      isTradingTask: false,
    },
  ],
  'spooky-treats-festival-lv2': [
    {
      title: 'Clear trading task missions',
      requiredCondition: 'Complete all 5 trading tasks',
      obtainToken: 1,
      isTradingTask: false,
    },
    {
      title: 'Every time you reach a volume of',
      requiredCondition: '1,000,000 USDT',
      obtainToken: 1,
      isTradingTask: false,
    },
    {
      title: 'Exchange',
      requiredCondition: '10 Eyeball Candies',
      obtainToken: 1,
      isTradingTask: false,
    },
  ],
  'spooky-treats-festival-lv3': [
    {
      title: 'Every time you reach a volume of',
      requiredCondition: '10M USDT',
      obtainToken: 1,
      isTradingTask: false,
    },
    {
      title: 'Exchange',
      requiredCondition: '10 Skull Lollipops',
      obtainToken: 1,
      isTradingTask: false,
    },
  ],
};
